import schemaToTypeGuard from 'sitemodel/schema/util/schemaToTypeGuard'
import schemaToReactType from 'sitemodel/schema/util/schemaToReactType'
import TaskExecutorSchema from 'sitemodel/schema/components/TaskExecutorSchema'
import { YesObject } from '@yes.technology/react-toolkit'

type Process = YesObject & {
  execution_state: string
}

export type Task = YesObject & {
  workflow?: [Process]
}

export type Node = {
  uuid: string
}

export type TaskExecutorProps = schemaToReactType<typeof TaskExecutorSchema>

export const TaskExecutorTypeGuard = schemaToTypeGuard(TaskExecutorSchema)
